import stalco from "assets/icons/stalco.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { products } from "utils/constants/constants";
import { isNotNull } from "utils/types/typeguards";

function TechnologyPartners() {

	const { t } = useTranslation();

	const stalcoPageId = products.find(product => product.name === "Stalco")?.id;

	return (
		<div className="container">
			<div className="grid grid-cols-1 lg:grid-cols-2 gap-0 xs:gap-7 lg:gap-16 place-items-center mt-20">
				<div className="text-gray-900 xs:text-3xl md:text-4xl lg:text-5xl font-medium leading-10 text-center lg:text-left">
					{ t("mainPage.technologyPartner.title") }
				</div>
				<div className="px-10 py-6 bg-stone-50 rounded-3xl shadow flex-col justify-center items-center gap-4 flex">
					{
						isNotNull(stalcoPageId)
							?
							<Link to={ `/products/${ stalcoPageId }` }>
								<img src={ stalco } alt="STALCO_LOGO"/>
							</Link>
							:
							<img src={ stalco } alt="STALCO_LOGO"/>
					}
				</div>
			</div>
		</div>
	);
}

export default TechnologyPartners;